<template>
    <tr :class="[{clickable: $_loggedUser_action_allowed('users', 'read'), disabled: !isActive, updated: isLastVisited(user.id) }]"
        @click="goToDetail($event, user.id)">
        <td class="no_padding drag_drop"><span></span></td>
		<td class="no_padding">
      <span class="lock" :title="$gettext('Sdílená váha. Nelze editovat.')" v-if="!$_updateActionAllowed && !amILoggedUser" />
			<input
					type="checkbox"
					:id="user.id"
					:value="user.id"
					@click.stop
					@change="onChange"
					:checked="isChecked"
			/>
			<label :for="user.id" @click.stop v-translate>Vybrat</label>
		</td>
      <span class="lock" v-if="!$_updateActionAllowed" 	:title="'Sdílená váha. Nelze editovat.' | translate" v-translate>Zamčeno</span>
      <td :data-th="'Příjmení jméno' | translate" class="first_data"><strong>{{ user.name }}</strong></td>
        <td :data-th="'Role' | translate">{{ roleName }}</td>
        <td :data-th="'Operátor' | translate" v-if="showOperator">
          <entity-link :id="user.id_operator" type="operator">{{ user.operator_name }}</entity-link>
        </td>
        <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(user.date_created)"></td>
        <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(user.date_updated)"></td>
		<td class="no_padding edit">
			<div class="edit_inner" v-if="!amILoggedUser">
				<a
						v-if="!isActive && $_loggedUser_action_allowed('users', 'update')"
						class="btn btn_action btn_grey btn_enable"
												:title="'Aktivovat' | translate"
						@click.prevent.stop="emitUpdateUser({active: true})"
						v-translate>Aktivovat
				</a>
				<a
            v-if="isActive && $_loggedUser_action_allowed('users', 'update')"
            class="btn btn_action btn_grey btn_disable"
						:title="'Deaktivovat' | translate"
						@click.prevent.stop="emitUpdateUser({active: false})"
						v-translate>Deaktivovat
				</a>
				<a
            v-if="$_loggedUser_action_allowed('users', 'delete')"
						class="btn btn_action btn_delete"
						:title="'Smazat' | translate"
						@click.prevent.stop="emitDeleteUser"
						v-translate>Smazat
				</a>
			</div>
		</td>
    </tr>
</template>

<script>
import userSettings from "@/components/mixins/user-settings"
import EntityLink from "../../common/EntityLink.vue";

export default {
		name: "UserRow",
    components: { EntityLink },
		mixins: [userSettings],
		data() {
			return {
				moduleName: 'users',
			}
		},
		props: {
			user: Object,
			selectedUsers: Array,
            showOperator: {
				type: Boolean,
                default: false,
            }
		},
		computed: {
			userId() {
				return String(this.user.id)
			},
			amILoggedUser() {
				return this.userId === String(this.$store.getters.getLoggedUserId)
			},
			isActive() {
				return this.user.active
			},
			isChecked() {
				return this.selectedUsers.indexOf(this.userId) > -1
			},
			roleName() {
        switch(this.user.role){
          case 'ROLE_OPERATOR':
            return this.$gettext('Operátor');
          case 'ROLE_ADMIN':
            return this.$gettext('Administrátor');
          case 'ROLE_OWNER':
            return this.$gettext('Majitel');
          case 'ROLE_READ_ONLY':
            return this.$gettext('Pouze ke čtení');
          default:
            return this.user.role;
        }
			}
		},
		methods: {
			onChange: function (e) {
				this.$emit('input', e)
			},
			goToDetail(e, id) {
        if(this.$_loggedUser_action_allowed('users', 'read')) {
          this.$router.push({name: 'userDetail', params: {id: id}})
        }
			},
			emitUpdateUser(params) {
				this.$emit('updateUser', {'id': this.userId, 'params': params})
			},
			emitDeleteUser() {
				this.$emit('deleteUser', this.userId)
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/users/UserRow.vue